<script>
	import { pageNumber, model } from "../../stores";
	import { referralTypes } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import contactRelationshipToClaimant from "../../config/relationshipToClaimant";
	import { getTealiumID } from "../../tealium";

	import Contact from "../../components/Contact.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import Select from "../../components/Select.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let title = null;
	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;

	let required = true;
	let showContactDetails = false;

	if (!disabled) {
		$pageNumber = pageIndex;
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		$model.TealiumId = getTealiumID();
	}
</script>

<PageSection>
	<h2>Your Contact Details</h2>

	<Contact
		bind:salutation={$model.Contact.Title}
		bind:firstName={$model.Contact.FirstName}
		bind:surname={$model.Contact.Surname}
		bind:dateOfBirth={$model.Contact.DateOfBirth}
		bind:emailAddress={$model.Contact.EmailAddresses[0].EmailAddress}
		bind:phoneNumber={$model.Contact.PhoneNumbers[0].PhoneNumber}
		bind:address={$model.Contact.Addresses[0]}
		idPrefix="cont"
		{required}
		{disabled}
	></Contact>

	<FormRow>
		<FormColumn>
			<Select
				{required}
				{disabled}
				label="Who are you registering for?"
				id="registrationType"
				bind:value={$model.RegistrationType}
				optionList={registrationTypes.options}
				textProperty="name"
				valueProperty="value"
			></Select>
		</FormColumn>
	</FormRow>

	{#if $model.RegistrationType == registrationTypes.types.SomeoneElse.value}
		<h2>Claimant Details</h2>

		<Contact
			bind:showContactDetails
			bind:salutation={$model.Claimant.Title}
			bind:firstName={$model.Claimant.FirstName}
			bind:surname={$model.Claimant.Surname}
			bind:dateOfBirth={$model.Claimant.DateOfBirth}
			bind:emailAddress={$model.Claimant.EmailAddress}
			bind:phoneNumber={$model.Claimant.PhoneNumber}
			bind:address={$model.Claimant.Address}
			idPrefix="claim"
			{required}
			{disabled}
		></Contact>

		<FormRow>
			<FormColumn>
				<Select
					{required}
					{disabled}
					label="Please specify your relationship to the claimant"
					id="relationshipToClaimant"
					bind:value={$model.RelationshipToClaimant}
					optionList={contactRelationshipToClaimant.options}
					textProperty="name"
					valueProperty="value"
				></Select>
			</FormColumn>
		</FormRow>

		<FormRow>
			<FormColumn>
				<Checkbox
					id="auth"
					{disabled}
					required="true"
					bind:checked={$model.AuthorisedToAct}
					label="I am authorised to act on behalf of the Individual"
				></Checkbox>
			</FormColumn>
		</FormRow>
	{/if}

	<div class="form-row">
		<div class="form-group col-md-12">
			<Checkbox
				{required}
				{disabled}
				bind:checked={$model.PrivacyPolicyConfirmed}
				label="I agree to the Shine Lawyers <a target='_blank' href='https://www.shine.com.au/privacy-policy'>privacy policy</a>"
			></Checkbox>
		</div>
	</div>

	<div class="form-row">
		<div class="form-group col-md-12">
			<label for="whereDidYouHear" class:isrequired={required}>Where did you hear about our firm?</label>
			<Select
				{required}
				{disabled}
				id="whereDidYouHear"
				bind:value={$model.WhereDidYouHear}
				optionList={referralTypes}
				textProperty="name"
				valueProperty="name"
			></Select>
		</div>
	</div>

	{#if !disabled}
		<div class="form-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} tealiumTag={true} pageName={title}
				></NavigationButtons>
			</div>
		</div>
	{/if}
</PageSection>
